'use strict';

var cov_u8khnw8f0 = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/logger.js',
      hash = '2fd0475faeea676a4e452cc974dbb3e2b5c37ff6',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/logger.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 12,
          column: 4
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 10,
          column: 5
        }
      },
      '2': {
        start: {
          line: 5,
          column: 6
        },
        end: {
          line: 9,
          column: 7
        }
      },
      '3': {
        start: {
          line: 6,
          column: 8
        },
        end: {
          line: 6,
          column: 40
        }
      },
      '4': {
        start: {
          line: 7,
          column: 13
        },
        end: {
          line: 9,
          column: 7
        }
      },
      '5': {
        start: {
          line: 8,
          column: 8
        },
        end: {
          line: 8,
          column: 41
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 31
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: 'logger',
        decl: {
          start: {
            line: 2,
            column: 18
          },
          end: {
            line: 2,
            column: 24
          }
        },
        loc: {
          start: {
            line: 2,
            column: 34
          },
          end: {
            line: 12,
            column: 3
          }
        },
        line: 2
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }, {
          start: {
            line: 4,
            column: 4
          },
          end: {
            line: 10,
            column: 5
          }
        }],
        line: 4
      },
      '1': {
        loc: {
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        }, {
          start: {
            line: 5,
            column: 6
          },
          end: {
            line: 9,
            column: 7
          }
        }],
        line: 5
      },
      '2': {
        loc: {
          start: {
            line: 5,
            column: 10
          },
          end: {
            line: 5,
            column: 44
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 5,
            column: 10
          },
          end: {
            line: 5,
            column: 27
          }
        }, {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 5,
            column: 44
          }
        }],
        line: 5
      },
      '3': {
        loc: {
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 9,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 9,
            column: 7
          }
        }, {
          start: {
            line: 7,
            column: 13
          },
          end: {
            line: 9,
            column: 7
          }
        }],
        line: 7
      },
      '4': {
        loc: {
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 73
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 7,
            column: 17
          },
          end: {
            line: 7,
            column: 55
          }
        }, {
          start: {
            line: 7,
            column: 59
          },
          end: {
            line: 7,
            column: 73
          }
        }],
        line: 7
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (level) {
  cov_u8khnw8f0.f[0]++;
  cov_u8khnw8f0.s[0]++;

  return function logger() {
    cov_u8khnw8f0.f[1]++;
    cov_u8khnw8f0.s[1]++;

    /* eslint-disable no-console */
    if (console) {
      cov_u8khnw8f0.b[0][0]++;
      cov_u8khnw8f0.s[2]++;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if ((cov_u8khnw8f0.b[2][0]++, level === 'error') && (cov_u8khnw8f0.b[2][1]++, console.error)) {
        cov_u8khnw8f0.b[1][0]++;
        cov_u8khnw8f0.s[3]++;

        console.error.apply(null, args);
      } else {
          cov_u8khnw8f0.b[1][1]++;
          cov_u8khnw8f0.s[4]++;
          if ((cov_u8khnw8f0.b[4][0]++, process.env.NODE_ENV === 'development') && (cov_u8khnw8f0.b[4][1]++, console[level])) {
            cov_u8khnw8f0.b[3][0]++;
            cov_u8khnw8f0.s[5]++;

            console[level].apply(null, args);
          } else {
            cov_u8khnw8f0.b[3][1]++;
          }
        }
    } else {
      cov_u8khnw8f0.b[0][1]++;
    }
    /* eslint-enable */
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wh/overlay-messaging/dist/logger.js
// module id = 1
// module chunks = 0